import React, { useState, useEffect, useContext, useRef } from 'react';
import { Link } from 'react-router-dom';
import { Image } from 'react-bootstrap';
import { commonGetService, handleFilterApi } from '../../utils/properties';
import { useAppSelector, useAppDispatch } from '../../app/hooks';
import { showToast } from '../../features/Toaster/toastslice';
import { AccessInfo, activityContext } from '../../pages/Dashboard';
import Skeleton from 'react-loading-skeleton';
import NotTrackedModal from './NotTrackedModal';
import '../../styles/Dashboard/notTrackedList.scss';
import { useNavigate } from 'react-router-dom';

export interface UnTracked {
    image: string;
    email: string;
    department: string;
    designation: string;
    employee_id: number;
    employee_code: string;
    employee_name: string;
    reason: string;
    device_id: string;
    date: number;
}

interface PropsObject {
    "isTablet": boolean
}

const NotTrackedList: React.FC<PropsObject> = ({ isTablet }) => {
    const [trackedLoading, setTrackedLoading] = useState<boolean>(false);
    const [unTrackedUsers, setUntrackedUsers] = useState<UnTracked[]>([]);
    const [notTrackedModal, setNotTrackedModal] = useState<boolean>(false);

    const targetRef = useRef<HTMLDivElement>(null);
    const filterData = useAppSelector((state) => state.filterData);
    const dispatch = useAppDispatch();
    const {
        startDate,
        endDate,
        empDeviceId,
        filterType,
        organization,
        department,
    } = filterData; // Destructuring the filterData state value

    //Details for Roles based UI
    const accessInfo: AccessInfo = useContext(activityContext)?.accessInfo as AccessInfo;

    const navigate = useNavigate();

    useEffect(() => {
        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    if (accessInfo["Haven't Tracked"]) {
                        getUntrackedUsersList();
                    }
                    observer.disconnect();
                } else {
                }
            },
            {
                root: null,
                rootMargin: "0px",
                threshold: 0.25,
            }
        );

        if (targetRef.current) {
            observer.observe(targetRef.current);
        }

        // Cleanup function to disconnect the observer when the component unmounts
        return () => {
            observer.disconnect();
        };
    }, [startDate, endDate, filterType, organization, department, accessInfo])

    const getUntrackedUsersList = () => {
        setTrackedLoading(true);
        commonGetService(
            `/api/1.0/dashboard/users/untracked?${handleFilterApi(
                startDate,
                endDate,
                filterType,
                organization,
                empDeviceId,
                department,
                false
            )}`
        ).then((res) => {
            setTrackedLoading(false);
            if (res.status === 200) {
                setUntrackedUsers(res?.data);
            }
            else {
                dispatch(
                    showToast({
                        message: "Something went wrong in API.",
                        status: "retry",
                        visible: true,
                    })
                );
            }
        });
    };

    const handleModalClose = () => {
        setNotTrackedModal(false);
    }

    return (
        <>
            <div className='not-tkd-container d-flex flex-column' ref={targetRef}>
                <div className="d-flex justify-content-between align-items-center common-card-title">
                    <h5>Yet to track</h5>
                    {unTrackedUsers?.length > 7 &&
                        <div className="report-link" onClick={() => setNotTrackedModal(true)}>+{unTrackedUsers?.length - 7} employees</div>
                    }
                </div>
                <div className='d-flex card-ctr'>
                    {trackedLoading ?
                        (Array.from({ length: (isTablet ? 4 : 7) })?.map((res, i) =>
                            <div className='user-card d-flex flex-column' key={i}>
                                <div className='d-flex align-items-center img-des-ctr'>
                                    <div className='img-ctr'>
                                        <Skeleton count={1} circle={true} className="skel-chart" />
                                    </div>
                                    <div className='des-ctr d-flex flex-column w-100'>
                                        <p><Skeleton className="w-100" count={1} /></p>
                                        <p><Skeleton className="w-100" count={1} /></p>
                                    </div>
                                </div>
                                <hr />
                                <div className='d-flex flex-column reason-ctr'>
                                    <h6>Reason</h6>
                                    <p><Skeleton className="w-100" count={1} /></p>
                                </div>
                            </div>
                        )) :
                        unTrackedUsers?.length ? unTrackedUsers?.filter((_, i) => isTablet ? (i < 4) : (i < 7))?.map((res, i) => (
                            <div className='user-card d-flex flex-column' key={i}>
                                <div className='d-flex align-items-center img-des-ctr'>
                                    <div className='img-ctr'>
                                        {res?.image ?
                                            <Image src={res?.image} alt='Not tracked employee' /> :
                                            <div className="img-avatar d-flex justify-content-center align-items-center">
                                                <p>{res?.employee_name?.charAt(0)}</p>
                                            </div>
                                        }
                                    </div>
                                    <div className='des-ctr d-flex flex-column'>
                                       <p 
    style={{ cursor: 'pointer' }} 
    onClick={() => navigate('/employeeOverview', { state: { empCode: res?.employee_code } })}
>
    {res?.employee_name}
</p>
                                        <p>{res?.designation}</p>
                                    </div>
                                </div>
                                <hr />
                                <div className='d-flex flex-column reason-ctr'>
                                    <h6>Reason</h6>
                                    <p>{res?.reason}</p>
                                </div>
                            </div>
                        )) : null}
                </div>
            </div>
            <NotTrackedModal show={notTrackedModal} handleModalClose={handleModalClose} unTrackedUsers={unTrackedUsers} />
        </>
    );
};

export default NotTrackedList;